export default {
    //语言配置规则：Array index0=简体，index1=繁体，，index2=英文 
    header: {
        home:['首页','首頁','Home'],
        
        about:['关于我们','關於我們','about'],
        language:['语言','語言','Language'],
        english:['英语','英語','ENGLISH'],
        zh_hk:['繁体中文','繁體中文','ZH-HK'],
        zh_cn:['简体中文','簡體中文','ZH-CN'],
    }
}


// WEBPACK FOOTER //
// ./src/assets/language_package.js